import React, { useState } from "react";
import PropTypes from "prop-types";

import { Radio } from "semantic-ui-react";

function ApplyChangeAtOptions({ allowApplyAtRenewal, onChange }) {
  const [currentSelection, setSelection] = useState(false);

  if (!allowApplyAtRenewal)
    return (
      <div data-test="apply-change-label" style={{ fontWeight: "bold" }}>
        The changes will be applied immediately.
      </div>
    );

  return (
    <div
      data-test="apply-change-options"
      style={{ display: "flex", gap: "1.5em" }}
    >
      <div data-test="apply-change-label" style={{ fontWeight: "bold" }}>
        When do you want the changes to start?
      </div>
      <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
        {[
          { text: "Immediately", value: false },
          { text: "Apply at renewal", value: true },
        ].map(({ text, value, disabled = false }) => {
          return (
            <Radio
              key={text}
              name="applyAtRadioGroup"
              label={text}
              disabled={disabled}
              checked={value === currentSelection}
              onChange={() => {
                setSelection(value);
                onChange(value);
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

ApplyChangeAtOptions.propTypes = {
  allowApplyAtRenewal: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

ApplyChangeAtOptions.defaultProps = {
  allowApplyAtRenewal: false,
};

export default ApplyChangeAtOptions;
